import * as React from "react";
const SvgFiRrBooksMedical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-books-medical_svg__a)">
      <path
        fill="#062147"
        d="M23.927 20.125 19.956 2.396A3.004 3.004 0 0 0 16.375.121l-.976.218a3 3 0 0 0-1.23.594 3 3 0 0 0-2.17-.931h-6c-1.654 0-3 1.346-3 3v2a1 1 0 1 0 2 0v-2c0-.551.448-1 1-1h2v6a1 1 0 1 0 2 0v-1h3v10h-3v-1a1 1 0 1 0-2 0v6h-2c-.552 0-1-.449-1-1v-2a1 1 0 1 0-2 0v2c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3v-8.706l2.097 9.364a3.01 3.01 0 0 0 3.58 2.271l.976-.218a2.99 2.99 0 0 0 1.881-1.321c.43-.678.569-1.482.394-2.265zM15.953 7.398l2.928-.655 2.267 10.122-2.929.654zm-.118-5.108s1.122-.242 1.195-.242c.188 0 .372.053.534.156a1 1 0 0 1 .44.627l.439 1.96-2.928.655-.439-1.962a1 1 0 0 1 .759-1.194M10 5V2h2c.552 0 1 .449 1 1v2zm2 17h-2v-3h3v2c0 .551-.448 1-1 1m9.844-.683a1 1 0 0 1-.627.44l-.976.218a1.003 1.003 0 0 1-1.193-.756l-.392-1.749 2.929-.653.391 1.745a.99.99 0 0 1-.132.755M3 13H1a1 1 0 1 1 0-2h2V9a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2H5v2a1 1 0 1 1-2 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-books-medical_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBooksMedical;
